import invariant from 'invariant'
import { schema as schemas } from 'normalizr'
import { CallApi } from '@signavio/kraken'
import qs from 'qs'

import { TaskFiltersType, PaginatedTasksType } from '../../../types'

import { schema as taskSchema } from './tasks'

export const collection = 'tasksPaginated'

export const schema = new schemas.Entity(
  collection,
  {
    tasks: taskSchema,
  },

  {
    idAttribute: ({ pageNumber, queryString }: PaginatedTasksType) => {
      const { sorting, pagesize, offset, _, ...rest } = qs.parse(queryString)

      const parts = []

      if (pagesize != null) {
        invariant(
          typeof pagesize === 'string',
          `Expected "pagesize" to be a string bot got "${typeof pagesize}"`
        )

        parts.push(`pagesize:${pagesize}`)
      }

      if (offset != null) {
        invariant(
          typeof offset === 'string',
          `Expected "offset" to be a string bot got "${typeof offset}"`
        )

        parts.push(`offset:${offset}`)
      }

      parts.push(`pageNumber:${pageNumber}`)

      if (sorting != null) {
        invariant(
          typeof sorting === 'string',
          `Expected "sorting" to be a string bot got "${typeof sorting}"`
        )

        parts.push(`sorting:${sorting}`)
      }

      const filters = Object.entries(rest).map(([key, value]) =>
        [key, JSON.stringify(value)].join(':')
      )

      parts.push(`filters::${filters.join(',')}`)

      return parts.join(';')
    },
  }
)

type RequestParamsType = {
  pagesize: number
  offset: number
  sorting: string
}

export const fetch =
  (callApi: CallApi, apiBase: string) =>
  (
    taskFilters: TaskFiltersType,
    _: unknown,
    { offset, pagesize, sorting }: RequestParamsType
  ) => {
    const requestParams = qs.stringify(
      { ...taskFilters, sorting, offset, pagesize },
      {
        arrayFormat: 'brackets',
        addQueryPrefix: true,
      }
    )

    return callApi(`${apiBase}/tasksPaginated${requestParams}`, schema)
  }
